export const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount);

export const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

export const generateId = () => Date.now().toString(36) + Math.random().toString(36).slice(2);

export const exportToCSV = (transactions) => {
  const headers = ["Date", "Description", "Category", "Type", "Amount"];
  const rows = transactions.map((t) => [t.date, t.description, t.category, t.type, t.amount]);
  const csv = [headers, ...rows].map((r) => r.join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = "transactions.csv"; a.click();
  URL.revokeObjectURL(url);
};

export const exportToJSON = (transactions) => {
  const blob = new Blob([JSON.stringify(transactions, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = "transactions.json"; a.click();
  URL.revokeObjectURL(url);
};

export const getFilteredTransactions = (transactions, filters) => {
  let result = [...transactions];
  if (filters.search) {
    const q = filters.search.toLowerCase();
    result = result.filter((t) => t.description.toLowerCase().includes(q) || t.category.toLowerCase().includes(q));
  }
  if (filters.category !== "all") result = result.filter((t) => t.category === filters.category);
  if (filters.type !== "all") result = result.filter((t) => t.type === filters.type);
  result.sort((a, b) => {
    if (filters.sortBy === "date") {
      return filters.sortOrder === "desc" ? b.date.localeCompare(a.date) : a.date.localeCompare(b.date);
    } else {
      return filters.sortOrder === "desc" ? b.amount - a.amount : a.amount - b.amount;
    }
  });
  return result;
};

export const getSummary = (transactions) => {
  const income = transactions.filter((t) => t.type === "income").reduce((s, t) => s + t.amount, 0);
  const expense = transactions.filter((t) => t.type === "expense").reduce((s, t) => s + t.amount, 0);
  return { income, expense, balance: income - expense };
};
